import { styled } from "../../styles";

// Scroll lives INSIDE this container (not the body). Mirrors
// ArticleBuilder.ScrollableContainer so the purple Header stays fixed at top
// and no horizontal body scroll appears when the vertical scrollbar takes
// width.
export const PageContainer = styled("div", {
  marginTop: "62px",
  width: "100%",
  height: "calc(100vh - 62px)",
  overflowY: "scroll",
  display: "flex",
  justifyContent: "center",
  padding: "0 40px",
  boxSizing: "border-box",
  backgroundColor: "$gray-20",
});

export const OuterCard = styled("div", {
  // fit-content + minHeight lets the card match content height when there are
  // many rules, while always covering the viewport at minimum. Mirrors
  // ArticleBuilder.BodyContainer.
  width: "100%",
  maxWidth: "1160px",
  height: "fit-content",
  minHeight: "calc(100vh - 62px)",
  backgroundColor: "$white",
  border: "1px solid $gray-40",
  padding: "0 48px",
  display: "flex",
  flexDirection: "column",
  boxSizing: "border-box",
});

export const InnerGrayPanel = styled("div", {
  flex: "1 0 auto",
  width: "100%",
  backgroundColor: "rgba(248,248,248,0.8)",
  padding: "32px 24px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  boxSizing: "border-box",
});

export const SectionBlock = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

export const SectionTitle = styled("h3", {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "16px",
  color: "$charcoal",
  margin: 0,
});

export const SectionCard = styled("div", {
  backgroundColor: "$white",
  borderRadius: "2px",
  padding: "32px 40px",
});

export const FieldRow = styled("div", {
  display: "flex",
  gap: "22px",
  flexWrap: "wrap",
});

export const FieldColumn = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "10px",
});

export const FieldLabelRow = styled("div", {
  display: "flex",
  gap: "4px",
  alignItems: "center",
  height: "16px",
});

export const FieldLabel = styled("label", {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "16px",
  color: "$charcoal",
});

export const RequiredMark = styled("span", {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  fontWeight: 600,
  lineHeight: "16px",
  color: "$charcoal",
});

export const ReadOnlyValue = styled("div", {
  height: "42px",
  display: "flex",
  alignItems: "center",
  padding: "0 16px",
  border: "1.2px solid $gray-50",
  borderRadius: "6px",
  backgroundColor: "$white",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  color: "$black",
  width: "240px",
  boxSizing: "border-box",
});

export const RulesContainer = styled("div", {
  display: "flex",
  flexDirection: "column",
  gap: "20px",
});

// Horizontal separator between rule blocks (same 1px $gray-50 line used as the
// divider elsewhere in the app).
export const RuleDivider = styled("div", {
  height: "1px",
  width: "100%",
  background: "$gray-50",
});

export const SkeletonRow = styled("div", {
  display: "flex",
  gap: "22px",
  alignItems: "center",
  flexWrap: "wrap",
});

export const AddRuleButton = styled("button", {
  all: "unset",
  alignSelf: "flex-start",
  padding: "5px 18px",
  borderRadius: "8px",
  backgroundColor: "$black",
  color: "$white",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "22px",
  cursor: "pointer",
  display: "inline-flex",
  alignItems: "center",
  gap: "6px",
  height: "32px",
  boxSizing: "border-box",

  "&:hover": {
    opacity: 0.9,
  },

  "&:disabled": {
    opacity: 0.5,
    cursor: "not-allowed",
  },
});

export const PlusSign = styled("span", {
  fontFamily: "'Open Sans', sans-serif",
  fontWeight: 600,
  fontSize: "16px",
  lineHeight: "22px",
});

export const EmptyRulesHint = styled("div", {
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "14px",
  color: "$gray-80",
  padding: "8px 0",
});
